import { useAuth } from '@/features/auth';
import { AgentDashboardView } from './AgentDashboardView';
import { HRDashboardView } from './HRDashboardView';
import { FMODashboardView } from './FMODashboardView';

export const DashboardContainer: React.FC = () => {
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="p-6">
        <div className="bg-white rounded-lg shadow p-12">
          <p className="text-gray-600 text-center">Please log in to view the dashboard</p>
        </div>
      </div>
    );
  }

  switch (user.role) {
    case 'agent':
      return <AgentDashboardView />;
    case 'hr_manager':
      return <HRDashboardView />;
    case 'fmo_ceo':
      return <FMODashboardView />;
    default:
      return (
        <div className="p-6">
          <div className="bg-white rounded-lg shadow p-12">
            <p className="text-gray-600 text-center">Unauthorized access</p>
          </div>
        </div>
      );
  }
};
